import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import Plane from '../icons/stepper/Plane';
import CompletedStep from '../icons/stepper/CompletedStep';
import IncompleteStep from '../icons/stepper/IncompleteStep';

import { breakpoints } from '../../utils/breakpoints';
import { getIntakeStepIndicators, getProgramMatchStepIndicators } from '../../utils/getStepIndicators';

const ScreenReaderQuestionHeading = styled.div`
  position: absolute;
  width: 0.0625rem;
  height: 0.0625rem;
  padding: 0;
  margin: -0.0625rem;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;

const StepperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${props => props.isAdmin ? '0.50rem' : '0.55rem'} ;
  margin-top: 1.91375rem;
  margin-bottom: 1.8125rem;
  margin-right: ${props => props.isAdmin ? '10px' : ''} ;
  margin-left: ${props => props.isAdmin ? '10px' : ''} ;
  @media ${breakpoints.tablet} {
    justify-content: center;
    gap: ${props => props.isAdmin ? '0.50rem' : '0.9375rem'};
    margin-top: 7rem;
    margin-bottom: 7rem;
    margin-right: ${props => props.isAdmin ? '10px' : 'auto'} ;
    margin-left: ${props => props.isAdmin ? '10px' : 'auto'} ;
  }
  @media ${breakpoints.mobile} {
    flex-wrap: wrap;
    justify-content: center;
  }
  @media ${breakpoints.desktop} {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
`;

const StepperItem = styled.div`
  svg {
    width: 14px;
    height: 14px;
  }

  .plane-icon {
    width: 26px;
    height: 24px;
  }

  @media ${breakpoints.tablet} {
    svg {
      width: 24px;
      height: 24px;
    }

    .plane-icon {
      width: 46px;
      height: 41px;
    }
  }
`;

export default function TravelerFormStepper({ step, forProgramMatch, isAdmin }) {
  const intakeQuestions = useSelector(state=>state.intakeForm.intakeQuestions);
  const intakeState = useSelector(state => state.intakeForm);
  const programMatchState = useSelector(state => state.programMatchForm);
  
  
  const steps = forProgramMatch
    ? getProgramMatchStepIndicators(programMatchState, Number(step))
    : getIntakeStepIndicators(intakeState, Number(step), intakeQuestions, isAdmin);

  const currentStepNumber = steps.find(step => step.current)?.step;
  return (
    <>
      <ScreenReaderQuestionHeading>
        Step {currentStepNumber} of {steps.length}
      </ScreenReaderQuestionHeading>
      <StepperContainer isAdmin={isAdmin} aria-hidden="true">
        {steps.map(step => (
          <StepperItem key={`step-${step.step}`}>
            {step.current && <Plane />}
            {!step.current && step.completed && <CompletedStep width={24} height={24} />}
            {!step.current && !step.completed && <IncompleteStep width={24} height={24} />}
          </StepperItem>
        ))}
      </StepperContainer>
    </>
  );
}

TravelerFormStepper.propTypes = {
  step: PropTypes.string.isRequired,
  forProgramMatch: PropTypes.bool.isRequired,
};
